import CellLink from '@/components/GokuDataGrid/CellLink'
import { useModal } from '@/contexts/modal'
import { generatePathDatacentral, paths } from '@/utils/path'
import { TFunction } from 'i18next'
import { Button, Typogaphy } from 'vnetwork-ui'
import { GridColDefVNW } from 'vnetwork-ui/dist/components/DataGridPro'
import { SupplierCandidateContact } from '../../../types'

const SupplierCandidateAction = ({
    row,
    t,
}: {
    row: SupplierCandidateContact
    t: TFunction
}) => {
    const { setModal } = useModal()

    // No "Xem NCC" branch: getSupplierCandidates requests exclude_linked=true, so a confirmed
    // contact never reaches this list.
    return (
        <Button
            variant="contained"
            onClick={() =>
                setModal('ContractModals/SupplierModal/index', {
                    mode: 'create',
                    supplier: {
                        customer_id: row.customer_id,
                        customer_contact_id: row.customer_contact_id,
                        partner_name: row.customer_name || row.contact_name,
                        partner_email: row.contact_email,
                        partner_phone: row.contact_phone,
                        partner_representative: row.contact_name,
                        partner_status: 'active',
                    },
                })
            }
        >
            {t('create-supplier')}
        </Button>
    )
}

export const supplierCandidateColumns = (
    t: TFunction
): GridColDefVNW<SupplierCandidateContact>[] => [
    {
        field: 'contact_name',
        headerName: t('contact_name'),
        sortable: false,
        renderCell: ({ row }) => (
            <CellLink
                to={`${generatePathDatacentral(paths.customerDetail, {
                    id: String(row?.customer_id),
                })}?contact_id=${row?.customer_contact_id}`}
            >
                {row?.contact_name || '-'}
            </CellLink>
        ),
        minWidth: 220,
        flex: 1,
    },
    {
        field: 'customer_name',
        headerName: t('customer_name'),
        sortable: false,
        renderCell: ({ row }) => (
            <CellLink
                to={generatePathDatacentral(paths.customerDetail, {
                    id: String(row?.customer_id),
                })}
            >
                {row?.customer_name || '-'}
            </CellLink>
        ),
        minWidth: 200,
    },
    {
        field: 'contact_email',
        headerName: t('email'),
        sortable: false,
        minWidth: 220,
    },
    {
        field: 'contact_phone',
        headerName: t('phone'),
        sortable: false,
        width: 140,
    },
    {
        field: 'contact_roles',
        headerName: t('roles'),
        sortable: false,
        renderCell: ({ row }) => (
            <Typogaphy>{row?.contact_roles?.join(', ') || '-'}</Typogaphy>
        ),
        width: 160,
    },
    // No linked-state column here: getSupplierCandidates requests exclude_linked=true, so this tab
    // only ever receives contacts that are not suppliers yet. A badge that always reads
    // "Chưa liên kết" would be noise, and the tab title already says it.
    {
        field: 'actions',
        headerName: t('actions'),
        sortable: false,
        renderCell: ({ row }) => <SupplierCandidateAction row={row} t={t} />,
        width: 180,
    },
]
